export default "/images/VectorMsg.svg?4a526469a59885eacb602cd1acdf7fcb";